import { format } from "date-fns";
import { Clock, Building2, Shield } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

interface ProfileSummaryProps {
  profile: any;
  isLoading?: boolean;
}

export function ProfileSummary({ profile, isLoading = false }: ProfileSummaryProps) {
  if (isLoading) {
    return <ProfileSummarySkeleton />;
  }

  const formatDate = (date: Date | null | undefined) => {
    if (!date || isNaN(date.getTime())) return "Never";
    return format(date, "PPp");
  };

  return (
    <Card className="p-6 space-y-6">
      <div className="space-y-4">
        <h3 className="text-sm font-medium">Account Information</h3>
        <div className="space-y-2 text-sm">
          <div className="flex items-center gap-2 text-muted-foreground">
            <Clock className="h-3.5 w-3.5" />
            <span>Last Login: {formatDate(profile?.last_login)}</span>
          </div>
          <div className="flex items-center gap-2 text-muted-foreground">
            <Clock className="h-3.5 w-3.5" />
            <span>Account Created: {formatDate(profile?.created_at)}</span>
          </div>
          {profile?.updated_at && new Date(profile.updated_at).getTime() !== new Date(profile.created_at).getTime() && (
            <div className="flex items-center gap-2 text-muted-foreground">
              <Clock className="h-3.5 w-3.5" />
              <span>Last Updated: {formatDate(profile?.updated_at)}</span>
            </div>
          )}
        </div>
      </div>
    </Card>
  );
}

function ProfileSummarySkeleton() {
  return (
    <Card className="p-6 space-y-6">
      <div className="space-y-4">
        <Skeleton className="h-4 w-24" />
        <div className="space-y-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className="flex items-center gap-2">
              <Skeleton className="h-4 w-4" />
              <Skeleton className="h-4 w-48" />
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}